module.exports = "../../../../platform/assets/pageMainIcon/icon-tongyong-1-purple.svg";